import type { FormField } from '@cli-types/core-engine/schema.js'
import { isFormFieldType } from '@core-engine/schema/field-type-guards/is-form-field-type.js'

export function isSupportedFormFieldType(field: FormField): boolean {
  return typeof field.type === 'string' && isFormFieldType(field.type)
}
